import { render, staticRenderFns } from "./pieza.vue?vue&type=template&id=207d1d0d"
import script from "./pieza.vue?vue&type=script&lang=js"
export * from "./pieza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports